// src/hooks/useLogin.js
import { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../services/firebase';
import { useAuthContext } from './useAuthContext';
import { getFirebaseErrorMessage } from '../utils/authValidation';
import { getUserStatus } from '../services/firebase/user-profile';

export const useLogin = () => {
  const [error, setError] = useState(null);
  const [isPending, setIsPending] = useState(false);
  const { dispatch } = useAuthContext();

  const login = async (email, password) => {
    setError(null);
    setIsPending(true);
    
    try {
      // Login
      const res = await signInWithEmailAndPassword(auth, email, password);

      // Check if user is on waitlist
      const statusResult = await getUserStatus(res.user.uid);
      
      if (statusResult.success && statusResult.data.status === 'waitlist') {
        // User is on waitlist - keep them authenticated
        // The App.js routing will automatically redirect them to /waitlist
        // Note: We dispatch LOGIN so AuthContext knows they're authenticated
        dispatch({ type: 'LOGIN', payload: res.user });
        
        setIsPending(false);
        setError(null);
        
        return { 
          success: true, 
          user: res.user, 
          isWaitlistUser: true,
          message: 'You are on the waitlist. Please wait for approval.'
        };
      }

      // Dispatch login action for non-waitlist users
      dispatch({ type: 'LOGIN', payload: res.user });
      
      setIsPending(false);
      setError(null);
      
      return { success: true, user: res.user, isWaitlistUser: false };
    } 
    catch (err) {
      console.error('Login error:', err.message);
      const errorMessage = getFirebaseErrorMessage(err.code);
      setError(errorMessage);
      setIsPending(false);
      return { success: false, error: errorMessage };
    }
  };

  return { login, isPending, error };
};